<template>
  <main>
    <div class="all-loading" v-if="someLoading || closingStatus">
      <div class="message">
        <a-progress
            v-if="closingStatus"
            type="circle"
            :percent="closingPercent"
            :status="closingStatus == 'error' ? 'exception' : ''"
        />
        <template v-else>
          <loading-outlined v-if="loadingStatus === ''" style="font-size: 120px" spin/>
          <a-progress v-else-if="loadingStatus === 'success'" type="circle" :percent="100"/>
          <a-progress v-else-if="loadingStatus === 'error'" type="circle" :percent="100" status="exception"/>
          <div class="mTop20 text" v-if="loadingMessage !== ''">
            {{ loadingMessage }}
          </div>
          <div v-if="loadingNeedClose">
            <a-button @click="stopLoading()" class="mTop20" type="primary">Закрыть</a-button>
          </div>
        </template>
      </div>
    </div>

    <template v-if="checkRecord">
      <router-view/>
    </template>
    <template v-else>
      <div class="all-loading" v-if="authLoading"></div>
      <template v-else-if="auth.isAdmin || auth.control || auth.isMaster || auth.isManager">
        <div class="top-block">
          <div class="pc-header displayFlexSBRN">
            <div class="displayFlex">
              <router-link class="logo" :to="{ name: 'HomeView' }">
                <logo/>
              </router-link>
              <Menu/>
            </div>
            <div class="displayFlex">
              <change-loader/>
              <UserInfo/>
            </div>
          </div>
          <div class="mobile-header">
            <div class="displayFlex">
              <router-link class="logo" :to="{ name: 'HomeView' }">
                <logo/>
              </router-link>
              <Menu/>
            </div>
            <div class="displayFlex">
              <change-loader/>
              <UserInfo/>
            </div>
          </div>
        </div>
        <div class="page-block">
          <router-view/>
        </div>
      </template>
      <user-auth v-else/>
    </template>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserAuth from "@/components/user/Auth";
import Logo from "@/components/logo";
import Menu from "@/components/menu";
import UserInfo from "@/components/user/Info";
import ChangeLoader from "@/components/ChangeLoader";

export default {
  name: 'App',
  components: { ChangeLoader, UserInfo, Menu, Logo, UserAuth },
  data() {
    return {
      location: document.location
    };
  },
  computed: {
    ...mapGetters({
      auth: "auth",
      closingStatus: "closingStatus",
      closingPercent: "closingPercent",
      loading: "loading",
      loadingMessage: "loadingMessage",
      loadingStatus: "loadingStatus",
      loadingNeedClose: "loadingNeedClose"
    }),
    checkRecord() {
      return [ '/login', '/record' ].includes(location.pathname) || location.pathname.includes('/record/')
    },

    authLoading: function () {
      return this.auth === false;
    },
    someLoading: function () {
      return this.loading === true;
    }
  },
  watch: {
    auth: {
      handler(newData, oldData) {
        const isNowLoggedIn = newData?.status === true && (!oldData || oldData.status === false);
        const isNowLoggedOut = oldData?.status === true && newData?.status === false;

        if (isNowLoggedIn) {
          // Пользователь успешно вошел в систему
          this.WSConnectionClose();
          this.WSConnect();
          this.handleWSConnectionOpen();
        }

        if (isNowLoggedOut) {
          this.WSConnectionClose();
          this.WSConnect();
          this.handleWSConnectionOpen();
        }
      },
      deep: true // Если auth — это сложный объект, отслеживаем изменения внутри него
    }
  },
  mounted() {
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  created() {
    this.getAuth();
    this.WSConnect();
    this.handleWSConnectionOpen();
  },
  beforeUnmount() {
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    this.WSConnectionClose();
  },
  methods: {
    ...mapActions([ "getAuth", 'stopLoading', 'WSConnect', 'WSConnectionOpen', 'WSConnectionClose' ]),

    handleVisibilityChange() {
      // Если пользователь вернулся во вкладку (или разблокировал телефон)
      if (document.visibilityState === "visible") {
        console.log("📱 Вкладка активна. Принудительно проверяем сокет...");

        // Вызываем глобальный экшен проверки связи из стора
        // Если сокет "умер" в фоне, эта цепочка поднимет его заново
        this.$store.dispatch('WSConnect');

        // savedAuthData у нас уже лежит в сторе, поэтому сокет сам переоткроется
        const savedData = this.$store.state.activeSubscriptions; // опционально для дебага
      }
    },

    handleWSConnectionOpen() {
      if (this.auth && this.auth.status === true && this.auth.user) {
        this.WSConnectionOpen({
          groups: this.auth.groups,
          idUser: this.auth.user.idUser,
          idBranch: this.auth.currentBranch
        });
      } else {
        // Если это гость — шлем пустой вызов (Vuex сам подставит гостевой uuid из кук)
        this.WSConnectionOpen({
          idBranch: this.auth.currentBranch
        });
      }
    }
  }
}
</script>

<style>
#app {
  overflow: hidden;
}
</style>